import { useState } from "react";
import { Button, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import NewPasswordInput, { PasswordChangedEventArgs } from "./components/NewPasswordInput";
import * as UserStore from "../../store/user/User";
import { ApplicationState } from "../../store";

function PasswordReset() {
    const dispatch = useDispatch();

    const user = useSelector((state: ApplicationState) => state.user);
    const [verificationCode, setVerificationCode] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [isNewPasswordValid, setIsNewPasswordValid] = useState(false);

    function handleVerificationCodeChange(event: React.ChangeEvent<HTMLInputElement>) {
        event.preventDefault();
        setVerificationCode(event.target.value);
    }

    function onNewPasswordChanged(data: PasswordChangedEventArgs) {
        setNewPassword(data.password);
        setIsNewPasswordValid(data.isValid);
    }

    function confirmResetPassword(event: React.MouseEvent<HTMLButtonElement>) {
        event.preventDefault();
        dispatch(UserStore.actionCreators.completePasswordReset(verificationCode, newPassword));
    }

    return (
        <>
            <div className="login-title">Password Reset</div>
            <div className="login-fields">
                <p>Please enter the verification code that was emailed to you, and create a new password.</p>

                <Form.Group className="gap-2 d-flex flex-column">
                    <Form.Control type="text" placeholder="Verification Code" onChange={handleVerificationCodeChange} />

                    <NewPasswordInput passwordChanged={onNewPasswordChanged} />

                    <div className="mt-1 text-center">
                        {user?.loginIssue && user?.loginIssueParams?.error?.name == "ExpiredCodeException" && (
                            <div className="text-danger mt-1 mb-3">
                                <div>Verification code has expired.</div>
                                <div style={{ fontSize: "smaller" }}>Verification codes expire after 1 hour</div>
                            </div>
                        )}
                    </div>
                </Form.Group>
            </div>

            <div className="login-actions">
                <Button onClick={confirmResetPassword} disabled={!isNewPasswordValid}>
                    Reset Password
                </Button>
            </div>
        </>
    );
}

export default PasswordReset;
